
import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Caregivers from './components/Caregivers';
import ConciergeForm from './components/ConciergeForm';
import Safety from './components/Safety';
import Footer from './components/Footer';
import { ViewMode } from './types';

const App: React.FC = () => {
  const [view, setView] = useState<ViewMode>(ViewMode.LANDING);

  const handleNavigate = (v: ViewMode) => {
    setView(v);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderContent = () => {
    switch (view) {
      case ViewMode.SAFETY:
        return <Safety onBack={() => setView(ViewMode.LANDING)} />;
      case ViewMode.BOOKING:
        return (
          <div className="pt-20 pb-12 bg-slate-50 min-h-screen">
            <ConciergeForm onBack={() => setView(ViewMode.LANDING)} />
          </div>
        );
      case ViewMode.LANDING:
      default:
        return (
          <>
            <Hero onBook={() => handleNavigate(ViewMode.BOOKING)} />
            <Services onBook={() => handleNavigate(ViewMode.BOOKING)} />
            <Caregivers />
          </>
        );
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header 
        currentView={view} 
        onNavigate={handleNavigate} 
      />
      <main className="flex-grow">
        {renderContent()}
      </main>
      <Footer onNavigate={handleNavigate} />
    </div>
  );
};

export default App;
